import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const EditUser = () => {
  const [formData, setFormData] = useState({
    ruolo: "Admin",
  });
  const [oldFormData, setOldFormData] = useState({
    ruolo: "Admin",
  });
  const [schoolOptions, setSchoolOptions] = React.useState([]);
  const [fullSchoolData, setFullSchoolData] = React.useState([]);

  const rolesOptions = [
    {
      label: "Admin",
      value: "Admin",
    },
  ];

  const breadcrumb = {
    current_section: "Aggiungi utente",
    sections: [
      { name: "Utenti e permessi", route_name: null, params: [] },
      { name: "Nuovo utente", route_name: null, params: [] },
    ],
  };

  const handleSave = async () => {
    const fetchOptions = getFetchOptions(
      "application/json",
      { adminId: formData.id, adminData: formData },
      "PUT"
    );
    await fetch(
      `${axios.defaults.baseBFFUrl}/fe/updateAdmin`,
      fetchOptions
    ).then((response) => {
      if (response.status !== 200) {
        alert("Errore durante il salvataggio dell'utente.");
        return;
      }

      window.location = "/users";
    });
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllSchools`,
          fetchOptions
        );
        const result = await response.json();

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchoolOptions(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );
        setFullSchoolData(result);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchUserData = async () => {
      const userId = window.location.href.split("/").pop();

      const fetchOptions = getFetchOptions("application/json", [], "GET");
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/getAdmin?adminId=${userId}`,
        fetchOptions
      );
      const result = await response.json();
      setFormData(result);
      setOldFormData(result);
    };

    fetchSchools();
    fetchUserData();
  }, []);

  useEffect(() => {
    if (formData.idscuola) {
      const selectedSchool = fullSchoolData.find(
        (school) => school.id === formData.idscuola
      );

      if (selectedSchool) {
        setFormData({
          ...formData,
          idcomune: selectedSchool.idcomune,
          idprovincia: selectedSchool.idprovincia,
        });
      }
    }
  }, [formData.idscuola]);
  // Funzione per validare il codice fiscale italiano
  const isValidCF = (cf) => {
    if (!cf) return false;
    const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
    return regex.test(cf);
  };

  // Stato per gestire l'errore del codice fiscale
  const [cfError, setCfError] = useState("");

  const isValidEmail = (email) => {
    if (!email) return false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [emailError, setEmailError] = useState("");

  // Modifica handleSave per controllare il codice fiscale
  const handleSaveWithCFCheck = async () => {
    let hasError = false;

    if (!isValidCF(formData.cf)) {
      setCfError("Codice fiscale non valido");
      hasError = true;
    } else {
      setCfError("");
    }

    if (!isValidEmail(formData.email)) {
      setEmailError("Email non valida");
      hasError = true;
    } else {
      setEmailError("");
    }

    if (!formData.nominativo) {
      alert("Il campo Nominativo è obbligatorio.");
      hasError = true;
    }
    if (!formData.idscuola) {
      alert("Il campo Scuola è obbligatorio.");
      hasError = true;
    }

    if (
      formData.cf !== oldFormData.cf ||
      formData.email !== oldFormData.email
    ) {
      const checkResponse = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/checkUserEmailAndCF?email=${formData.email}&cf=${formData.cf}&schoolId=${formData.idscuola}`,
        getFetchOptions("application/json", {}, "GET")
      );

      const checkResult = await checkResponse.json();

      if (formData.email !== oldFormData.email && checkResult.emailExists) {
        setEmailError("Email già utilizzata da un altro insegnante");
        return;
      }
      if (formData.cf !== oldFormData.cf && checkResult.cfExists) {
        setCfError("Codice Fiscale già utilizzato da un altro insegnante");
        return;
      }
    }

    if (hasError) return;

    await handleSave();
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb Component */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/users">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista utenti
        </button>
      </a>

      {/* General Data Card */}
      <div className="card custom-card">
        <div className="card-header">Dati generali</div>
        <form id="EditUserForm">
          <div className="card-body">
            <div className="row row-cols-1 row-cols-lg-3 mb-3">
              <div className="col-6 col-lg-4">
                <label htmlFor="ruolo">Ruolo</label>
                <Select
                  options={rolesOptions}
                  id="ruolo"
                  name="ruolo"
                  defaultValue={"Admin"}
                  value={rolesOptions?.filter(function (option) {
                    return option.value === formData.ruolo;
                  })}
                  onChange={(e) =>
                    setFormData({ ...formData, ruolo: e?.value })
                  }
                  classNames={"form-control"}
                  placeholder="Scegli ruolo..."
                  isDisabled
                />
              </div>
              <div className="col-6 col-lg-8">
                <label htmlFor="idscuola">
                  Scuola <b>*</b>
                </label>
                <Select
                  options={schoolOptions}
                  id="idscuola"
                  name="idscuola"
                  value={schoolOptions?.filter(function (option) {
                    return option.value === formData.idscuola;
                  })}
                  onChange={(e) =>
                    setFormData({ ...formData, idscuola: e?.value })
                  }
                  classNames={"form-control"}
                  placeholder="Scegli scuola..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label htmlFor="nominativo">
                  Nominativo <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="nominativo"
                  name="nominativo"
                  label="Nominativo"
                  value={formData.nominativo}
                  onChange={(e) =>
                    setFormData({ ...formData, nominativo: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6 col-lg-4">
                <label htmlFor="email">
                  Email <b>*</b>
                </label>
                <input
                  className={`form-control ${emailError ? "is-invalid" : ""}`}
                  id="email"
                  name="email"
                  label="Email"
                  value={formData.email}
                  onChange={(e) => {
                    setFormData({ ...formData, email: e.target.value });
                    if (emailError) setEmailError("");
                  }}
                />
                {emailError && (
                  <div className="invalid-feedback">{emailError}</div>
                )}
              </div>
              <div className="col-6 col-lg-4">
                <label htmlFor="telefono">Telefono</label>
                <input
                  className="form-control"
                  id="telefono"
                  name="telefono"
                  label="Telefono"
                  type="number"
                  value={formData.telefono}
                  onChange={(e) =>
                    setFormData({ ...formData, telefono: e.target.value })
                  }
                />
              </div>
              <div className="col-6 col-lg-4">
                <label htmlFor="cf">
                  Codice Fiscale <b>*</b>
                </label>
                <input
                  className={`form-control ${cfError ? "is-invalid" : ""}`}
                  id="cf"
                  name="cf"
                  label="Codice fiscale"
                  value={formData.cf}
                  onChange={(e) => {
                    setFormData({ ...formData, cf: e.target.value });
                    if (cfError) setCfError("");
                  }}
                />
                {cfError && <div className="invalid-feedback">{cfError}</div>}
              </div>
            </div>

            <div className="saveButtonContainer">
              <div
                id="saveTeacherBtn"
                name="saveTeacherBtn"
                className="btn btn-success saveButton"
                role="button"
                onClick={handleSaveWithCFCheck}
              >
                {" "}
                Salva{" "}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUser;
